/* eslint-disable simple-import-sort/imports*/
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import type { Instrumentation } from '@opentelemetry/instrumentation'
import type { MatchUrlDefinitions } from './types'

type DefaultInstrumentationsOptions = {
  ignoreUrls?: MatchUrlDefinitions
  propagateTraceHeaderCorsUrls?: MatchUrlDefinitions
}

export const initialIntrumentationsOptions = {
  ignoreUrls: [],
  propagateTraceHeaderCorsUrls: [],
}

/**
 * This function returns an array of default OpenTelemetry instrumentations for TypeScript, including
 * web auto-instrumentations, document load, fetch, XMLHttpRequest, and user interaction.
 * @param {DefaultInstrumentationsOptions} options - The `options` parameter is an optional object that
 * contains configuration options for the `XMLHttpRequestInstrumentation`. It is set to
 * `initialIntrumentationsOptions` by default if no value is provided.
 * @returns The function `getDefaultOTELInstrumentations` is returning an array of
 * `InstrumentationOption` objects. The array contains instances of various instrumentations such as
 * `DocumentLoadInstrumentation`, `FetchInstrumentation`, `XMLHttpRequestInstrumentation`,
 * `UserInteractionInstrumentation`, and `getWebAutoInstrumentations`. The specific instrumentations
 * being returned may vary depending on the `options` parameter passed to the
 */
export function getDefaultOTELInstrumentations(options: DefaultInstrumentationsOptions): Instrumentation[] {
  return [
    ...getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-document-load': { enabled: false },
      '@opentelemetry/instrumentation-user-interaction': { enabled: false },
      '@opentelemetry/instrumentation-fetch': { enabled: false }, // Use manual FetchInstrumentation instead
      '@opentelemetry/instrumentation-xml-http-request': {
        enabled: false,
        ignoreUrls: options.ignoreUrls,
        propagateTraceHeaderCorsUrls: options.propagateTraceHeaderCorsUrls,
      },
    }),
  ]
}
